var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-list-item', [_c('v-autocomplete', {
    attrs: {
      "items": _vm.partners,
      "item-text": _vm.getFieldText,
      "persistent-hint": "",
      "cache-items": "",
      "return-object": "",
      "outlined": "",
      "solo": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-list-item-group', [_c('v-list-item', {
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.companyName) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.getAddressText(item)) + " ")])], 1)], 1)], 1)];
      }
    }]),
    model: {
      value: _vm.partner,
      callback: function callback($$v) {
        _vm.partner = $$v;
      },
      expression: "partner"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }